// Twitter is branded X, but the stored platform key, the API values, the
// campaign target names and the icon registry are all still `twitter`.
// Renaming those would break campaign submission, source filtering and every
// `SOCIAL_ICONS[key]` lookup, so the rename lives at the render edge only:
// the value stays `twitter`, the label reads "X (Twitter)".

export const X_TWITTER_LABEL = 'X (Twitter)'

// Every spelling the app has carried for the platform, so a label comes out
// whatever the call site holds — a raw key, an already-prettified name, or one
// of the older "Twitter (X)" / "X" labels this replaces.
const TWITTER_ALIASES = new Set([
  'twitter',
  'twitter (x)',
  'twitter.com',
  'x',
  'x (twitter)',
  'x.com',
])

export const isTwitterPlatform = (value?: string | null): boolean =>
  !!value && TWITTER_ALIASES.has(value.trim().toLowerCase())

/**
 * The label to print for a platform.
 *
 * `fallback` is whatever the call site rendered before — returned untouched
 * for every other platform, so wrapping a label in this can only ever change
 * Twitter.
 */
export const platformDisplayLabel = (
  value?: string | null,
  fallback?: string
): string => {
  if (isTwitterPlatform(value)) {
    return X_TWITTER_LABEL
  }

  return fallback ?? value ?? ''
}
